<template>
  <v-container fluid>
    <payroll-payment-report-container-view />
  </v-container>
</template>

<script>
  export default {
    components: {
      PayrollPaymentReportContainerView: () => import('@/components/hris/payroll/report/PaymentReport'),
    },
  }
</script>
